<div class="container p-0 w-[33rem]" *ngIf="formGroup">
  <mat-dialog-content class="text-black text-base">
    <div class="modal-dialog p-10">
      <div class="modal-content">
        <div class="text-center pb-8">
          <h4
            class="flex flex-row gap-4 justify-center text-2xl text-dark_blue"
          >
            <app-warning-icon
              class="text-danger"
              variant="large"
            ></app-warning-icon>
            Confirm Updates
          </h4>
        </div>
        <div class="modal-body flex flex-col" [formGroup]="formGroup">
          <div>
            <div class="mb-4">We noticed changes in your NPI information.</div>
            <ng-container *ngFor="let difference of updates.differences">
              <div class="mb-2">
                <div>
                  {{ difference.property }} in our records:
                  <span class="font-semibold">{{ difference.ourValue }} </span>
                </div>
                <div>
                  {{ difference.property }} on NPI record:
                  <span class="font-semibold">{{ difference.npiValue }}</span>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="my-4 text-sm">
            <mat-checkbox formControlName="confirm"
              >I acknowledge the following changes are correct and authorize the
              system to update the following records.</mat-checkbox
            >
          </div>
        </div>
        <div class="modal-footer flex flex-col items-center gap-4 mt-4">
          <thera-button
            [disabled]="formGroup.get('confirm')?.value === false"
            [config]="continueButtonConfig"
            (clicked)="continue()"
          >
          </thera-button>
          <a class="text-dark_blue underline cursor-pointer" (click)="decline()"
            >Decline</a
          >
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
